import { createContext, useContext } from 'react';
import type { ShowcaseSignUpPlace, ShowcaseUpsellAction } from './showcaseActions';

/** What the parts of the showcase mode share (spec 2026-10-10 Studio showcase §4, design c). */
export interface MusicVideoShowcaseContextValue {
  /** `?embed=1`: the demo inside the frame of music24.com/music-video-maker. */
  isEmbed: boolean;
  /** The sign-up link with the intent `music-video`. */
  signUpHref: string;
  /** The action of the open sign-up card (design c2), or null. */
  upsell: ShowcaseUpsellAction | null;
  showUpsell: (action: ShowcaseUpsellAction) => void;
  closeUpsell: () => void;
  /** A sign-up button was pressed (the analytics event; the link itself opens the sign-up). */
  onSignUp: (place: ShowcaseSignUpPlace) => void;
}

export const MusicVideoShowcaseContext = createContext<MusicVideoShowcaseContextValue | null>(null);

/** The showcase of the open editor, or null in account mode. */
export function useMusicVideoShowcase(): MusicVideoShowcaseContextValue | null {
  return useContext(MusicVideoShowcaseContext);
}

/** The showcase of the open editor. Only the showcase parts call it: they render in showcase mode only. */
export function useRequiredMusicVideoShowcase(): MusicVideoShowcaseContextValue {
  const value = useContext(MusicVideoShowcaseContext);
  if (value === null) {
    throw new Error('A showcase part needs the MusicVideoShowcaseContext provider');
  }
  return value;
}
